import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import FormRow from 'components/form/FormRow'
import { PField, useFieldValue } from 'components/form/input/NestedField'
import { fieldHasError, requiredValidator } from 'components/form/input/validator'
import { useAllAtiveReunioes } from 'entity/Reuniao/funtions'
import React from 'react'


// const formatNde = d => d < 10 ? "0" + d : d

// const format = horario => {
//     let d = new Date(horario)
//     return formatNde(d.getHours()) + ":" + formatNde(d.getMinutes()) + " - "
//         + formatNde(d.getDate()) + "/" + formatNde(d.getMonth() + 1);
// }

// function CardHorario({ value, setValue, setValueTxt, horario, horariosMarcados }) {

//     let ativo = true
//     let colorStatus = "rgba(30,30,235,0.5)" //"#8f8feb"

//     if (value.horario === horario.horario) {
//         //É selecionado
//         colorStatus = "#2af765"
//     }
//     if (horariosMarcados.includes(horario.horario)) {
//         //ja esta marcado
//         colorStatus = "rgba(125,125,125,0.2)" //"#bdbdbd"
//         ativo = false
//     }

//     return <div
//         style={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: "center",
//             backgroundColor: colorStatus,
//             width: 200,
//             padding: 10,
//             margin: 10,
//             cursor: ativo ? 'pointer' : 'unset'

//         }}
//         onClick={() => {
//             if (ativo) {
//                 setValue(horario)
//                 setValueTxt(format(horario.horario))
//             }
//         }}
//     >
//         <Typography>{format(horario.horario)}</Typography>
//     </div>
// }
export default function SeletorHorarioReuniao({ uidReuniao, rodada, mesa }) {
    const [value, ] = useFieldValue("horario")
    const [valueTxt, ] = useFieldValue('horariotxt')

    // const possiveisReunioes = rodada ? rodada.possiveisReunioes : []
    const reunioes = useAllAtiveReunioes(rodada, mesa)

    // const horariosMarcados = reunioes ? reunioes.map(r => {
    //     if (uidReuniao !== r.uid) return r.horario?.horario
    //     return null
    // }) : []
    // console.log('reunioes', reunioes)
    // let exibe = rodada && mesa

    return (<PField
        name={"horario"}
        validate={requiredValidator}
    >
        {(fieldProps) => {
            const hasError = fieldHasError(fieldProps.meta);
            return <Box sx={{}}>
                <Typography variant='h6' sx={{}}>Horários* {value ? "- Marcado: " + valueTxt + " na " + mesa?.name : ""}</Typography>
                {hasError && <Typography sx={{ color: '#f00' }}>{fieldProps.meta.error}</Typography>}
                {!rodada ? <FormRow sx={{ display: "flex", justifyContent: 'center' }}>
                    <Typography sx={{ color: 'text.disabled' }}>- Informe a Rodada e a Mesa -</Typography>
                </FormRow> :
                    <>
                        {!mesa ? <FormRow sx={{ display: "flex", justifyContent: 'center' }}>
                            <Typography sx={{ color: 'text.disabled' }}>- Informe a Mesa -</Typography>
                        </FormRow> : <>
                            {!reunioes ? <FormRow sx={{ display: "flex", justifyContent: 'center' }}>
                                <Typography sx={{ color: 'text.disabled' }}>- Carregando reunião... -</Typography>
                            </FormRow> : <>
                                {/* {exibe && <Box sx={{ display: 'flex', flexWrap: "wrap" }}>

                                    {(possiveisReunioes).length !== 0
                                        ? (possiveisReunioes).map((horario, index) => (
                                            <CardHorario
                                                key={index}
                                                index={index}
                                                value={value}
                                                setValue={setValue}
                                                horario={horario}
                                                horariosMarcados={horariosMarcados}
                                                setValueTxt={setValueTxt}

                                            />
                                        ))
                                        : <FormRow sx={{ display: "flex", justifyContent: 'center' }}>
                                            <Typography sx={{ color: 'text.disabled' }}>- Sem horários -</Typography>
                                        </FormRow>
                                    }
                                </Box>} */}
                            </>
                            }
                        </>}
                    </>
                }
            </Box>
        }}</PField>
    )
}
